module.exports = __webpack_public_path__ + "img/onestop.ad7af1f4.svg";